/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import React from 'react';

import styled from 'styled-components';

import Spinner from '../Spinner';

const ActionButton = ({
  buttonText,
  callback,
  additionalStyles,
  isLoading,
  isDisabled,
  className = '',
  spinnerColor = 'white',
}) => (
  <ButtonContainer
    className={`action-button ${className}`}
    disabled={isDisabled}
    style={{...additionalStyles}}
    onClick={callback}
  >
    {isLoading ? <Spinner color={spinnerColor} className="spinner-container" /> : buttonText}
  </ButtonContainer>
);

const ButtonContainer = styled.button`
  padding: 1rem 0;
  background: ${(props) => props.theme.colors.brand.primary};
  border-radius: 52px !important;
  font-weight: bold !important;
  width: 100%;
  margin-top: 1rem;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: scale 300ms;

  :disabled {
    background-color: rgb(236, 236, 236) !important;
    color: rgb(161, 161, 161) !important;
    pointer-events: none;
  }

  :hover {
    scale: 1.02;
  }
  .spinner-container {
    margin: 0rem auto;
  }
`;

export default ActionButton;
